import React, { JSX } from 'react';
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import { observer } from "mobx-react";

const sentence = {
    visible: {
        transition: {
            delay: 2,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

export type StepperV1Props = {
    isVisible: boolean,
    title?: JSX.Element | string | null,
    desc?: JSX.Element | string | null,
    steps?: StepV1Props[]
}
export type StepV1Props = {
    title: JSX.Element | string,
    subtitle?: JSX.Element | string,
};

const StepperV1 = observer((props: StepperV1Props) => {

    let wrapClasses: string[] = [
        'stepper-v1', 'box-v1 box-v1_filling-type-outlined',
        'stepper-v1_titletext-color-type-main',
        'stepper-v1_desctext-color-type-main'
    ];

    if (props.isVisible === false) {
        wrapClasses.push('_hide');
        return (
            <div className={wrapClasses.join(' ')}></div>
        );
    }

    function renderHeadBlock(): JSX.Element | null {
        if (props.title !== null) {
            return (
                <div className="stepper-v1__head">
                    <div className="stepper-v1__head-title">{props.title}</div>
                    <div className="stepper-v1__head-desc">{props.desc}</div>
                </div>
            )
        }
        return null;
    }

    function renderTrack(): JSX.Element | null {
        if (props.steps?.length) {
            return (
                <div className="stepper-v1__track">
                    { props.steps.map((step, index) => {

                        let wrapClasses: string[] = [
                            'step-v1',
                            'step-v1_filling-color-type-secondary',
                            'step-v1_text-color-type-main',
                            'step-v1_filling-type-contained'
                        ];

                        return (
                            <div className={wrapClasses.join(' ')} key={`step-v1${index}`}>
                                <div className="step-v1__title">
                                    {step.title}
                                </div>
                                <motion.div
                                    className="step-v1__subtitle"
                                    variants={sentence}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {splitLine(String(step.subtitle))}
                                </motion.div>
                            </div>
                        );
                    }) }
                </div>
            )
        }
        return null;
    }

    return (
        <div className={wrapClasses.join(' ')}>
            { renderHeadBlock() }
            { renderTrack() }
        </div>
    );

})

export default StepperV1;